import { useCallback } from 'react';

import { useConditionState } from './useConditionState';
import { DateRange, GeoLocationValue, MultiGeoLocationValue } from '../../types';

export type ConditionValue =
  | string
  | number
  | boolean
  | DateRange
  | GeoLocationValue
  | MultiGeoLocationValue;

export const useValueState = () => {
  const { condition, setCondition } = useConditionState();
  const value = 'value' in condition ? condition.value : undefined;
  const setValue = useCallback(
    (newValue?: ConditionValue) =>
      setCondition((currentCondition) => ({ ...currentCondition, value: newValue })),
    [setCondition],
  );
  return { value, setValue };
};
